// TripInfoHeader — Presentational "Trip Info" summary box for the EditTripModal:
// the light-gray panel showing the Calendar icon, the formatted start/end date
// range, and the flights / hotels / car rentals counters separated by bullet
// dots.
//
// Extracted verbatim from `EditTripModal.js` (the "Trip Info" block) as part of
// the behavior-preserving refactor (issue #240). In the source the date range
// was computed by an inline IIFE and the counters were read off the trip; here
// those derived values arrive as props (the `dateRange` string from
// `formatTripDateRange(trip)` and the `counts` object from `getTripCounts(trip)`)
// so this component stays render-only. Wrapped in React.memo. Styles, the
// bullet separators (•), the "flights"/"hotels"/"car rentals" labels, and the
// Calendar icon (lucide-react) are identical to the source.
//
// Props:
//   dateRange - string; the formatted "MM/DD/YY - MM/DD/YY" label
//   counts    - { flights, hotels, carRentals } numeric counts
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

import React from 'react';
import { Calendar } from 'lucide-react';

export const TripInfoHeader = React.memo(function TripInfoHeader({
  dateRange,
  counts
}) {
  return (
    <div style={{
      marginBottom: '24px',
      padding: '16px',
      backgroundColor: '#f8fafc',
      borderRadius: '8px',
      border: '1px solid #e2e8f0'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        fontSize: '14px',
        color: '#6b7280'
      }}>
        <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <Calendar size={14} />
          {dateRange}
        </span>
        <span style={{ color: '#d1d5db' }}>•</span>
        <span>{counts.flights} flights</span>
        <span style={{ color: '#d1d5db' }}>•</span>
        <span>{counts.hotels} hotels</span>
        <span style={{ color: '#d1d5db' }}>•</span>
        <span>{counts.carRentals} car rentals</span>
      </div>
    </div>
  );
});

export default TripInfoHeader;
